import { injectable } from 'inversify';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ObjectManager } from '../../../concepts/objects';
import { Camera } from '../../canvas/Camera';
import { ContentPayload } from '../../canvas/injection/ContentPayload';
import { ContentProcessor } from '../../canvas/injection/ContentProcessor';
import { resolve } from '../../Container';
import { createGraphicFromUrl } from '../../packages/graphics/GraphicCommands';

@injectable()
export class GraphicFromHtmlFileProcessor implements ContentProcessor {

    public readonly supportedTypes = Object.freeze([
        'text/html',
    ]);

    @resolve(Camera) private camera!: Camera;
    @resolve(CommandDispatcher) private dispatch!: CommandDispatcher;
    @resolve(ObjectManager) private objects!: ObjectManager;

    public async process(payload: ContentPayload): Promise<boolean | ContentPayload> {
        const { data, metadata } = payload;

        // Check is file or blob or string
        if (!(typeof (data) === 'string' || data instanceof File || data instanceof Blob)) {
            // input must be a File or Blob.
            return false;
        }

        const textData = typeof (data) === 'string' ? data : await data.text();
        if (!textData) return false;

        // Is it an <img /> ?
        const match = textData.match(/<img[^>]+src="([^">]+)"/);
        if (!match) return false;

        const url = match[1];
        const [x, y] = metadata?.position?.toArray() ?? [];

        this.dispatch(createGraphicFromUrl, [url, x, y]);
        return true;
    }
}
